<div class="bg-card shadow-md rounded-md h-full w-full p-4 md:p-8 border">
  <form (ngSubmit)="generarReporte()">
    <div class="grid grid-cols-1 md:grid-cols-2 gap-x-4">
      <div
        *ngFor="let campo of reporteSeleccionado?.fields; let i = index"
        [class.col-span-2]="i === 0"
      >
        <mat-form-field appearance="fill" class="w-full my-2 fuse-mat-dense">
          <mat-label>{{ campo.label }}</mat-label>

          <!-- Campo texto -->
          <input
            *ngIf="campo.type === 'text'"
            matInput
            [(ngModel)]="params[campo.name]"
            [name]="campo.name"
          />

          <!-- Campo número -->
          <input
            *ngIf="campo.type === 'number'"
            matInput
            type="number"
            [(ngModel)]="params[campo.name]"
            [name]="campo.name"
          />

          <!-- Campo fecha -->
          <input
            *ngIf="campo.type === 'date'"
            matInput
            type="date"
            [(ngModel)]="params[campo.name]"
            [name]="campo.name"
          />
            <mat-select *ngIf="campo.type === 'select'" 
                [(ngModel)]="params[campo.name]" 
                [name]="campo.name"
                (selectionChange)="onSelectChange(campo.name, $event.value)">
                <mat-option *ngFor="let opt of campo.options" [value]="opt.value">
                    {{ opt.label }}
                </mat-option>
            </mat-select>

        </mat-form-field>
      </div>
    </div>

    <!-- Campos comunes -->
    <div class="flex gap-4">
      <mat-form-field appearance="fill" class="w-full my-2 fuse-mat-dense">
        <mat-label>Fecha Inicio</mat-label>
        <input matInput type="date" [(ngModel)]="params.fechaInicio" name="fechaInicio" />
      </mat-form-field>

      <mat-form-field appearance="fill" class="w-full my-2 fuse-mat-dense">
        <mat-label>Fecha Fin</mat-label>
        <input matInput type="date" [(ngModel)]="params.fechaFin" name="fechaFin" />
      </mat-form-field>
    </div>

    <mat-form-field appearance="fill" class="w-full my-2 fuse-mat-dense">
      <mat-label>Nombre del Reporte</mat-label>
      <input matInput type="text" [(ngModel)]="params.nombreReporte" name="nombreReporte" />
    </mat-form-field>

    <div class="flex w-full justify-end">
        <button mat-raised-button 
          color="primary" 
          type="submit" 
          class="rounded-md"
          [disabled]="!params.nombreReporte"
          >Generar Reporte</button>
    </div>
  </form>
</div>
